<template>
  <ion-page>
    <ion-progress-bar :value="0" v-show="$store.state.hide"></ion-progress-bar>
    <ion-content :scroll-events="true" style="">
      <Header-Section />
      <div class="main-wrapper">
        <section id="notifications-board">
          <div class="notification-title">
            <h2>
              Notifications({{ $store.state.unreadNotifications.length }})
            </h2>
            <button
              v-if="$store.state.unreadNotifications.length"
              @click="markAllAsRead"
            >
              Mark all as read
            </button>
            <button style="background: red" v-else>All Read</button>
          </div>
          <div
            class="friend-shift-box-moja"
            style="display: flex; justify-content: center; margin-top: 5px"
            v-if="$store.state.unreadNotifications == 0"
          >
            <div
              style="display: flex; justify-content: center; margin-top: auto"
            >
              <i><svg-icon width="80" height="80" name="bell" /></i
              ><span
                ><i><svg-icon width="40" height="40" name="bell" /></i
              ></span>
            </div>
            <br />
            <h5 style="text-align: center">
              When you have notifications, you'll see them here.
            </h5>
          </div>
          <div class="day-intro" v-if="$store.state.unreadNotifications.length">
            <p
              v-if="
                getHumanDate($store.state.unreadNotifications[0].timestamp) ==
                getHumanDate(new Date())
              "
            >
              Today
            </p>
            <p v-else>
              {{ getHumanDate($store.state.unreadNotifications[0].timestamp) }}
            </p>
          </div>
          <div
            v-for="(notif, index) in $store.state.unreadNotifications.slice(
              0,
              10
            )"
            :key="index"
          >
            <div
              class="day-intro yesterday"
              v-if="
                index > 0 &&
                getHumanDate(notif.timestamp) !==
                  getHumanDate(
                    $store.state.unreadNotifications[index - 1].timestamp
                  )
              "
            >
              <p>{{ getHumanDate(notif.timestamp) }}</p>
            </div>
            <div class="notifications-list">
              <div
                class="notification-moja"
                v-if="notif.data.nf_type === 'FriendRequest'"
                style="cursor: pointer"
                @click="$router.push(`/profile/${notif.data.user_id}`)"
              >
                <div class="time">
                  <p>{{ getHumanDate1(notif.timestamp) }}</p>
                </div>
                <div class="notification-type">
                  <span style="display: flex">
                    <i><svg-icon width="20" height="20" name="user" /></i
                    ><span
                      ><i><svg-icon width="10" height="10" name="user" /></i
                    ></span>
                  </span>
                </div>
                <div class="user-image">
                  <img
                    :src="`${this.$store.state.endpoints.appUrl}${notif.data.user_image}`"
                    alt=""
                  />
                </div>
                <div class="notification-itselfu">
                  <p>
                    <span class="color">{{ notif.data.user_name }}</span>
                    {{ notif.verb }}
                  </p>
                </div>
              </div>
              <div
                class="notification-moja"
                v-if="notif.data.nf_type === 'NewMessage'"
                @click="$router.push(`/chatroom`)"
                style="cursor: pointer"
              >
                <div class="time">
                  <p>{{ getHumanDate1(notif.timestamp) }}</p>
                </div>
                <div class="notification-type">
                  <span
                    ><i><svg-icon name="comment-icon" /></i
                  ></span>
                </div>
                <div class="user-image">
                  <img
                    :src="`${this.$store.state.endpoints.appUrl}${notif.data.user_image}`"
                    alt=""
                  />
                </div>
                <div class="notification-itselfu">
                  <p>
                    <span class="color">{{ notif.data.user_name }}</span> sent
                    you a message
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonRefresher,
  IonRefresherContent,
  IonPage,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonBackButton,
  IonHeader,
} from "@ionic/vue";
import HeaderSection from "./components/navBar/header.vue";
import moment from "moment";
import SvgIcon from "./SvgIcon.vue";
export default {
  components: {
    IonContent,
    IonRefresher,
    IonRefresherContent,
    IonPage,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonBackButton,
    IonHeader,
    HeaderSection,
    SvgIcon,
  },
  methods: {
    markAllAsRead() {
      axios
        .get(`${this.$store.state.endpoints.markAllAsRead}`, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
        })
        .then(() => {
          console.log();
          this.$store.dispatch("unreadNotifications");
        });
    },
    getHumanDate1: function (date) {
      return moment(String(date)).format("LT");
    },
    getHumanDate: function (date) {
      return moment(String(date)).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600&family=Raleway:wght@600&family=Work+Sans:wght@300;400&display=swap");
@import "./styles/font-poppins.css";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
body {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  background: rgb(250, 250, 250);
}
.inner-row {
  width: 90%;
  margin: auto;
}
.profile-image {
  width: 40px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.site-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}
header {
  width: 100%;
  background: white;
  position: fixed;
  z-index: 10;
  height: 70px;
  box-shadow: 0px 1px 2px rgb(231, 231, 231);
}
header .inner-row {
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .logo-section {
  width: 50px;
  height: 50px;
}
.logo-section img {
  width: 135px;
}
.left-nav,
.right-nav {
  display: flex;
  align-items: center;
}

header .search-bar {
  background: whitesmoke;
  margin-left: 5%;
  width: 300px;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
}
.search-control {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  color: #333;
}
.quick-links {
  margin-right: 5%;
  display: flex;
}
.quick-links .notify,
.quick-links .message {
  font-size: 1.5rem;
  cursor: pointer;
  color: rgb(80, 80, 80);
}
.profile-section {
  display: flex;
  align-items: center;
}
.profile-name {
  display: flex;
  align-items: center;
}
.profile-name h2 {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: rgb(80, 80, 80);
}
.profile-name span {
  font-size: 1.2rem;
  cursor: pointer;
}

.navTrigger {
  cursor: pointer;
  width: 30px;
  height: 25px;
  margin: auto;
  position: absolute;
  right: 20px;
  top: 20px;
  opacity: 0;
  z-index: inherit;
}
.navTrigger i {
  background: #222;
  width: 100%;
  content: "";
  display: block;
  height: 4px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  -o-border-radius: 2px;
}
.navTrigger i:nth-child(1) {
  animation: outTp 0.8s backwards;
  -webkit-animation: outTp 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(2) {
  margin: 5px 0;
  animation: outMd 0.8s backwards;
  -webkit-animation: outMd 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(3) {
  animation: outBtm 0.8s backwards;
  -webkit-animation: outBtm 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger.active i:nth-child(1) {
  -webkit-animation: inTp 0.8s forwards;
  animation: inTp 0.8s forwards;
}

.navTrigger.active i:nth-child(2) {
  -webkit-animation: inMd 0.8s forwards;
  animation: inMd 0.8s forwards;
}

.navTrigger.active i:nth-child(3) {
  -webkit-animation: inBtm 0.8s forwards;
  animation: inBtm 0.8s forwards;
}
/*Keyframes*/
@keyframes inMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes outMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes inTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes outTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

.main-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  gap: 20px;
  top: 70px;
  background: rgb(250, 250, 250);
}
.sidebar-nav {
  width: 250px;
  background: #fff;
  position: fixed;
  top: 90px;
  left: 50px;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  box-shadow: 0px 0px 6px -1px rgb(216, 216, 216);
}
.sidebar-nav.hide {
  margin-left: -250px;
  transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
}
.sidebar-nav nav ul li {
  display: block;
  padding-left: 15px;
  line-height: 45px;
  margin-bottom: 10px;
}
.sidebar-nav nav ul li:hover {
  background: rgb(247, 250, 252);
  transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -ms-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
}

.sidebar-nav nav ul li span {
  font-size: 20px;
}
.sidebar-nav nav ul li a {
  color: #111;
  display: flex;
  align-items: center;
  font-size: 15px;
}
.sidebar-nav nav ul li:hover a {
  color: rgba(0, 129, 204, 0.822);
}

.mobile-sidebar {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 40%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: -100%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
  display: none;
}
.mobile-sidebar.active {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: 0;
}
.mobile-nav-link {
  display: block;
  line-height: 40px;
  color: #222;
  font-size: 0.9rem;
}

.mobile-profile {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
}
.mobile-profile .profile-text p {
  font-size: 0.7rem;
  color: #444;
}
.mobile-sidebar .logout {
  padding: 0.5rem 0;
  margin-top: 1rem;
  border-top: 1px solid gainsboro;
}
.mobile-sidebar .logout a {
  font-size: 0.9rem;
  color: #222;
}

#notifications-board {
  margin-left: 320px;
  position: relative;
  width: 73%;
  margin-bottom: 100px;
  top: 20px;
}
.notification-title h2 {
  text-transform: uppercase;
  font-weight: 100;
  font-size: 24px;
  margin-bottom: 10px;
}
.notification-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.notification-title button {
  padding: 10px 20px;
  font-family: "Poppins";
  font-weight: 500;
  border: none;
  background: rgba(0, 129, 204, 0.822);
  color: white;
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  -ms-border-radius: 30px;
  -o-border-radius: 30px;
  cursor: pointer;
}
@media (max-width: 400px) {
  .notification-title {
    flex-direction: column;
  }
  .notification-title button {
    padding: 5px;
    font-size: 10px;
  }
}
.day-intro {
  display: inline-block;
}
.day-intro p {
  padding: 5px 10px;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  background: rgba(0, 129, 204, 0.822);
  color: white;
  font-size: 13px;
}
.day-intro::after {
  content: "";
  width: 2px;
  height: 10px;
  background: rgba(0, 129, 204);
  display: block;
  margin: 2px auto;
}
.day-intro.yesterday::before {
  content: "";
  width: 2px;
  height: 10px;
  background: rgb(0, 129, 204);
  display: block;
  margin: 2px auto;
}
.notifications-list {
  box-shadow: 0px 0px 6px -1px rgb(216, 216, 216);
  padding: 20px;
  background: #fff;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.notification-moja {
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 15px 0;
  position: relative;
}
.notification-moja::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: rgba(223, 223, 223, 0.336);
  display: block;
}

.notification-moja .user-image,
.user-image img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.notification-moja .time {
  font-size: 13px;
  color: #444;
}
.notification-moja .notification-type span {
  font-size: 25px;
  color: rgb(0, 129, 204);
}
.notification-itselfu p {
  font-size: 14px;
  color: #444;
}
.notification-itselfu p span {
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 129, 204);
}

@media (max-width: 1000px) {
  .mobile-sidebar {
    display: block;
  }
  .sidebar-nav {
    margin-left: -300px;
  }
  .sidebar-nav.show {
    margin-left: 0;
    z-index: 99;
  }
  #notifications-board {
    width: 90%;
    margin: auto;
  }
  .navTrigger {
    opacity: 1;
  }
  header .search-bar,
  .right-nav {
    display: none;
  }
}

@media (max-width: 600px) {
  .notification-moja .time {
    font-size: 10px;
  }
  .notification-title {
    text-align: center;
  }
}
@media (max-width: 350px) {
  .notification-moja {
    gap: 10px;
  }
  .notification-itselfu p {
    font-size: 12px;
  }
  .notification-itselfu p span {
    font-size: 14px;
  }
  .notification-moja .user-image,
  .user-image img {
    width: 30px;
    height: 30px;
  }
}
</style>
